import { render, staticRenderFns } from "./WechatoaPushTemp.vue?vue&type=template&id=04c2faeb&scoped=true"
import script from "./WechatoaPushTemp.vue?vue&type=script&lang=js"
export * from "./WechatoaPushTemp.vue?vue&type=script&lang=js"
import style0 from "./WechatoaPushTemp.vue?vue&type=style&index=0&id=04c2faeb&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c2faeb",
  null
  
)

export default component.exports